import axios from "axios"
const apiBaseUrl = process.env.REACT_APP_APIBASE_URL

let apiToken = JSON.parse(localStorage.getItem("authUser"))
let UserType = JSON.parse(localStorage.getItem("WWINGS_USER_TYPE"))

const headers = {
  "Access-Control-Allow-Origin": "*",
  "Content-Type": "application/json",
  Authorization: apiToken,
  Accept: "application/json",
  "Cache-Control": "no-cache",
}

export const addLeadAPI = async leadData => {
  try {
    let apiToken = JSON.parse(localStorage.getItem("authUser"))

    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }
    const response = await axios.post(`${apiBaseUrl}/createLead`, leadData, {
      headers,
    })
    return response
  } catch (error) {
    console.error("Error adding lead:", error)
    throw error
  }
}

//  to get lead

export const getLeadAPI = async payload => {
  let apiToken = JSON.parse(localStorage.getItem("authUser"))

  const headers = {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
    Authorization: apiToken,
    Accept: "application/json",
    "Cache-Control": "no-cache",
  }

  if (payload === "Admin") {
    return await axios.get(`${apiBaseUrl}/allLeads`, {
      payload,
      headers,
    })
  } else if (payload === "Employee") {
    return await axios.get(`${apiBaseUrl}/myLeads`, {
      payload,
      headers,
    })
  }
}

// GEt blocked leads
///get-all-closed-leads

export const getCloseLeadsApi = async payload => {
  let apiToken = JSON.parse(localStorage.getItem("authUser"))

  const headers = {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
    Authorization: apiToken,
    Accept: "application/json",
    "Cache-Control": "no-cache",
  }


  return await axios.get(`${apiBaseUrl}/get-all-closed-leads`, {
    headers,
  })

}
// to delete lead

export const deleteLeadAPI = async payload => {
  let apiToken = JSON.parse(localStorage.getItem("authUser"))
  console.log(apiToken)
  const headers = {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
    Authorization: apiToken,
    Accept: "application/json",
    "Cache-Control": "no-cache",
  }

  return await axios.post(`${apiBaseUrl}/deletelead`, payload.payload, {
    headers,
  })
}

export const EditLeadAPI = async leadData => {
  try {
    let apiToken = JSON.parse(localStorage.getItem("authUser"))

    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }
    const response = await axios.post(`${apiBaseUrl}/updateLead`, leadData, {
      headers,
    })
    return response
  } catch (error) {
    console.error("Error adding lead:", error)
    throw error
  }
}

//view-lead

export const ViewLeadAPI = async payload => {
  let apiToken = JSON.parse(localStorage.getItem("authUser"))

  const headers = {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
    Authorization: apiToken,
    Accept: "application/json",
    "Cache-Control": "no-cache",
  }

  const data = {
    id: payload,
  }
  try {
    const response = await axios.post(`${apiBaseUrl}/view-lead`, data, {
      headers,
    })
    return response
  } catch (error) {
    console.error("Error loading Lead:", error)
    throw error
  }
}

//create-lead log

export const CreateLeadLogAPI = async payload => {
  let apiToken = JSON.parse(localStorage.getItem("authUser"))

  const headers = {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
    Authorization: apiToken,
    Accept: "application/json",
    "Cache-Control": "no-cache",
  }

  try {
    const response = await axios.post(`${apiBaseUrl}/create-leadlog`, payload, {
      headers,
    })
    return response
  } catch (error) {
    console.error("Error creating Log:", error)
    throw error
  }
}

//Convert lead to customer

export const ConvertLeadApi = async payload => {
  let apiToken = JSON.parse(localStorage.getItem("authUser"))

  const headers = {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
    Authorization: apiToken,
    Accept: "application/json",
    "Cache-Control": "no-cache",
  }

  try {
    const response = await axios.post(
      `${apiBaseUrl}/leads-to-customer`,
      payload,
      {
        headers,
      }
    )
    return response
  } catch (error) {
    console.error("Error creating Log:", error)
    throw error
  }
}

//Close lead

export const CloseLeadApi = async payload => {
  let apiToken = JSON.parse(localStorage.getItem("authUser"))

  const headers = {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
    Authorization: apiToken,
    Accept: "application/json",
    "Cache-Control": "no-cache",
  }

  try {
    const response = await axios.post(`${apiBaseUrl}/closeLead`, payload, {
      headers,
    })
    return response
  } catch (error) {
    console.error("Error Closing lead api:", error)
    throw error
  }
}

// get close lead reasons

export const getCloseLeadReasonsAPI = async payload => {
  let apiToken = JSON.parse(localStorage.getItem("authUser"))

  const headers = {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
    Authorization: apiToken,
    Accept: "application/json",
    "Cache-Control": "no-cache",
  }

  return await axios.get(`${apiBaseUrl}/blocklead-reasons`, {
    headers,
  })
}
